const OffSiteHotels = () => {
	return (
		<>
			<p>
				Booking for La Cantera will be available in January 2027. An email will
				be sent out to dashboard users when the booking link is active.
			</p>

			{/*<p>
				Please use the link below to book your hotel rooms at La Cantera.
				Deadline to book is March 9, 2027.
			</p>*/}

			<p style={{ borderTop: "1px solid #ddd" }}></p>

			<h4
				style={{
					marginTop: "0",
					lineHeight: "22px",
					marginBottom: "0",
					fontSize: "1.1rem",
					color: "inherit",
					fontWeight: "bold",
				}}
			>
				La Cantera Resort & Spa
			</h4>

			<table
				className="approved assigned"
				style={{ marginTop: "15px", marginBottom: "10px" }}
			>
				<thead>
					<tr>
						<th className="left">
							<span style={{ fontSize: "1rem" }}>Cancellation Policy</span>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="left">
							<i>Cancellations</i> - Reservations require{" "}
							<b>full pre-payment</b> of room and tax at the time of book and
							are <b>non-refundable</b>.
						</td>
					</tr>

					<tr>
						<td className="left">
							<i>No Shows</i> - Guests who fail to check-in on their scheduled
							arrival date are subject to a penalty equal room and tax for their
							full stay - reservations will be released for resale after a no
							show.
						</td>
					</tr>

					<tr>
						<td className="left">
							<i>Early Departures</i> - Guests who check out prior to their
							scheduled departure date will be responsible for their full stay
							in early departure fees.
						</td>
					</tr>
				</tbody>
			</table>

			{/*<a
				href="https://book.passkey.com/event/51059190/owner/14234852/home"
				target="_blank"
				rel="noreferrer"
			>
				https://book.passkey.com/event/51059190/owner/14234852/home
			</a>*/}

			{/*<p style={{ borderTop: "1px solid #ddd" }}></p>
			<h4
				style={{
					marginTop: "0",
					lineHeight: "22px",
					marginBottom: "0",
					fontSize: "1.1rem",
					color: "inherit",
					fontWeight: "bold",
				}}
			>
				1. Drury Plaza Hotel San Antonio North Stone Oak
			</h4>
			<p
				style={{
					marginTop: "7.5px",
					marginBottom: "5px",
					color: "#a94442",
					lineHeight: "22px",
					fontSize: "1.1rem",
				}}
			>
				<strong>Sunday is sold out</strong>
			</p>
			<p
				style={{
					marginTop: "7.5px",
					marginBottom: "5px",
					fontStyle: "italic",
				}}
			>
				Deadline to book: <strong>March 8, 2024</strong>
			</p>
			<a
				href="https://www.druryhotels.com/bookandstay/newreservation/?groupno=10084017"
				target="_blank"
				rel="noreferrer"
			>
				https://www.druryhotels.com/bookandstay/newreservation/?groupno=10084017
			</a>
			<h4
				style={{
					marginTop: "15px",
					lineHeight: "22px",
					marginBottom: "0",
					fontSize: "1.1rem",
					color: "inherit",
					fontWeight: "bold",
				}}
			>
				2. Drury Inn & Suites San Antonio North Stone Oak
			</h4>
			<p
				style={{
					marginTop: "7.5px",
					marginBottom: "5px",
					color: "#a94442",
					lineHeight: "22px",
					fontSize: "1.1rem",
				}}
			>
				<strong>Sunday is sold out</strong>
			</p>
			<p
				style={{
					marginTop: "7.5px",
					marginBottom: "5px",
					fontStyle: "italic",
				}}
			>
				Deadline to book: <strong>March 8, 2024</strong>
			</p>
			<a
				href="https://www.druryhotels.com/bookandstay/newreservation/?groupno=10091416"
				target="_blank"
				rel="noreferrer"
			>
				https://www.druryhotels.com/bookandstay/newreservation/?groupno=10091416
			</a>
			<p>
				Please make your reservations by <strong>Friday, March 8, 2024</strong>{" "}
				to receive your group rate. Reservations made after this date will be
				subject to prevailing rates and availability. Reservations may also be
				made by calling 1-800-325-0720 and referring to your group number
				10084017.
			</p>
		
			<p style={{ borderTop: "1px solid #ddd" }}></p>
			<h4
				style={{
					marginTop: "0",
					lineHeight: "22px",
					marginBottom: "0",
					fontSize: "1.1rem",
					color: "inherit",
					fontWeight: "bold",
					textDecoration: "line-through",
				}}
			>
				4. Home2 Suites San Antonio at the Rim
			</h4>
			<p
				style={{
					marginTop: "7.5px",
					marginBottom: "5px",
					color: "#a94442",
					lineHeight: "22px",
					fontSize: "1.1rem",
				}}
			>
				<strong>SOLD OUT</strong>
			</p>
			<p
				style={{
					marginTop: "7.5px",
					marginBottom: "5px",
					fontStyle: "italic",
				}}
			>
				Deadline to book: <strong>March 8, 2024</strong>
			</p>
			<a
				href="https://group.home2suites.com/ae5ee6"
				target="_blank"
				rel="noreferrer"
			>
				https://group.home2suites.com/ae5ee6
			</a>
			<p>
				Reservations made after this date will be subject to prevailing rates
				and availability.
			</p>
			<p style={{ borderTop: "1px solid #ddd" }}></p>
			<h4
				style={{
					marginTop: "0",
					lineHeight: "22px",
					marginBottom: "0",
					fontSize: "1.1rem",
					color: "inherit",
					fontWeight: "bold",
					textDecoration: "line-through",
				}}
			>
				5. St. Anthony, a Luxury Collection Hotel
			</h4>
			<p
				style={{
					marginTop: "7.5px",
					marginBottom: "5px",
					color: "#a94442",
					lineHeight: "22px",
					fontSize: "1.1rem",
				}}
			>
				<strong>SOLD OUT</strong>
			</p>
			<p
				style={{
					marginTop: "7.5px",
					marginBottom: "5px",
					fontStyle: "italic",
				}}
			>
				Deadline to book: <strong>March 4, 2024</strong>
			</p>
			<a
				href="https://www.marriott.com/event-reservations/reservation-link.mi?id=1705965457403&key=GRP&app=resvlink"
				target="_blank"
				rel="noreferrer"
			>
				https://www.marriott.com/event-reservations/reservation-link.mi?id=1705965457403&key=GRP&app=resvlink
			</a>
			<p style={{ marginBottom: "25px" }}>
				Reservations made after this date will be subject to prevailing rates
				and availability.
			</p>
			<img
				src="https://vto.qnmcdn.com/assets/img/bfc-offsite-hotels-map.jpg?529"
				alt="map"
				style={{ width: "100%", height: "auto", display: "block" }}
			/>
			*/}
		</>
	);
};

export default OffSiteHotels;
